import { NgModule } from '@angular/core';
import { ObjectKeysPipe } from './object-keys.pipe';

@NgModule({
  imports: [],
  declarations: [ObjectKeysPipe],
  exports: [ObjectKeysPipe],
  providers: [ObjectKeysPipe],
})
export class ObjectKeysPipeModule {}
